import React from 'react'

const SelectsCard = (props) => {
  return (
    <div className='relative hover:cursor-pointer  '>
        <img className="w-full h-full object-cover rounded-lg" src={props.bg} alt="" />
        <div className='bg-gray-900/30 rounded-lg absolute top-0 left-0 w-full h-full'>
            <p className='bottom-4 left-4 text-2xl text-white absolute'>{props.text}</p>
        </div>
    </div>
  )
}

export default SelectsCard